import React, { useEffect, useState } from 'react';
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { getUsuarios } from '../../../services/apis';
import { useNavigate } from 'react-router-dom';

import {
	CircularProgress,
	Grid,
	TextField,
	Typography,
	Divider,
	FormControl,
	InputLabel,
	Select,
	MenuItem
} from '@mui/material';

import PersonIcon from '@mui/icons-material/Person';

import { UsuarioCard } from './UsuarioCard';
import { FormCrearUsuario } from './FormCrearUsuario';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';

export const Usuarios = () => {
	const navigate = useNavigate();

	// =========================
	// ESTADOS
	// =========================
	const [usuarios, setUsuarios] = useState([]);
	const [usuariosOG, setUsuariosOG] = useState([]);

	const [roles, setRoles] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);

	const [opciones, setOpciones] = useState([]);
	const [opcionesUsuario, setOpcionesUsuario] = useState([]);

	const [loaded, setLoaded] = useState(false);
	const [openCrearUsuario, setOpenCrearUsuario] = useState(false);

	const handleFiltroRol = (event) => {
		const value = event.target.value;
		setFiltroRol(value);
		aplicarFiltros({ rol: value });
	};
	const handleFiltroDepartamento = (event) => {
		const value = event.target.value;
		setFiltroDepartamento(value);
		aplicarFiltros({ departamento: value });
	};



	// =========================
	// EFFECT
	// =========================
	useEffect(() => {
		cargarUsuarios();
	}, []);

	// =========================
	// FILTROS
	// =========================
	const [filtroRol, setFiltroRol] = useState('');
	const [filtroDepartamento, setFiltroDepartamento] = useState('');
	const [busqueda, setBusqueda] = useState('');

	const aplicarFiltros = ({
		texto = busqueda,
		rol = filtroRol,
		departamento = filtroDepartamento
	}) => {
		let resultado = [...usuariosOG];

		if (texto) {
			resultado = resultado.filter(usu =>
				usu.nombre?.toLowerCase().includes(texto) ||
				usu.apellidos?.toLowerCase().includes(texto) ||
				usu.mail?.toLowerCase().includes(texto) ||
				usu.nombre_rol?.toLowerCase().includes(texto)
			);
		}

		if (rol) {
			resultado = resultado.filter(usu => String(usu.rol) === String(rol));
		}

		if (departamento) {
			resultado = resultado.filter(
				usu => String(usu.departamento) === String(departamento)
			);
		}

		setUsuarios(resultado);
	};
	// =========================
	// CARGAR USUARIOS
	// =========================
	const cargarUsuarios = async () => {
		try {
			const response = await getUsuarios();

			if (response.success === true) {
				setUsuarios(response.data.usuarios);
				setUsuariosOG(response.data.usuarios);

				setRoles(response.data.roles);
				setDepartamentos(response.data.departamentos);

				setOpciones(response.data.opciones);
				setOpcionesUsuario(response.data.opciones_usuario);

				setLoaded(true);
			} else {
				navigate('/');
			}
		} catch (error) {
			console.error('Error al cargar usuarios:', error);
			navigate('/');
		}
	};

	// =========================
	// MENÚ SUPERIOR
	// =========================
	const handleEvent = (opcionId) => {
		if (opcionId === 1) {
			setOpenCrearUsuario(true);
		}
	};

	// =========================
	// BUSCADOR
	// =========================
	const handleBusqueda = (event) => {
		const value = event.target.value.toLowerCase();
		setBusqueda(value);
		aplicarFiltros({ texto: value });
	};


	// =========================
	// RENDER
	// =========================
	return (
		<div className="menu-back fade-in2">
			<SubHeader titulo="Usuarios" />

			{!loaded && <CircularProgress />}

			{loaded && (
				<>
					{/* =========================
						MENÚ DE OPCIONES
					========================= */}
					<Grid container direction="column" size={{ xs: 12 }}>
						<OpcionesMenuFunc
							opciones={opciones}
							handleEvent={handleEvent}
						/>
					</Grid>

					{/* =========================
						CONTENEDOR PRINCIPAL
					========================= */}
					<Grid
						container
						direction="column"
						padding="1em"
						alignItems="center"
						size={{ xs: 12 }}
					>

						{/* TÍTULO */}
						<Grid container size={{ xs: 11 }}>
							<Typography variant="h4" gutterBottom>
								<PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
								Usuarios: {usuarios.length}
							</Typography>
						</Grid>

						{/* BUSCADOR */}
						<Grid
							container
							size={{ xs: 11 }}
							spacing={2}
							sx={{ mb: 2 }}
						>
							{/* BUSCADOR */}
							<Grid item size={{ xs: 12, sm: 4 }}>
								<TextField
									label="Buscar usuario..."
									variant="standard"
									size="small"
									fullWidth
									value={busqueda}
									onChange={handleBusqueda}
								/>
							</Grid>

							{/* FILTRO ROL */}
							<Grid item size={{ xs: 12, sm: 4 }}>
								<FormControl variant="standard" fullWidth size="small">
									<InputLabel>Rol</InputLabel>
									<Select
										value={filtroRol}
										onChange={handleFiltroRol}
									>
										<MenuItem value="">
											<em>Todos</em>
										</MenuItem>
										{roles.map(rol => (
											<MenuItem key={rol.id} value={rol.id}>
												{rol.nombre}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>

							{/* FILTRO DEPARTAMENTO */}
							<Grid item size={{ xs: 12, sm: 4 }}>
								<FormControl variant="standard" fullWidth size="small">
									<InputLabel>Departamento</InputLabel>
									<Select
										value={filtroDepartamento}
										onChange={handleFiltroDepartamento}
									>
										<MenuItem value="">
											<em>Todos</em>
										</MenuItem>
										{departamentos.map(dep => (
											<MenuItem key={dep.id} value={dep.id}>
												{dep.nombre}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						{/* CABECERA DE LISTADO (opcional, puedes estilizar luego) */}
						<Grid
							container
							size={{ xs: 11 }}
							sx={{
								px: 2,
								py: 1,
								borderBottom: '2px solid',
								borderColor: 'divider',
								fontWeight: 600
							}}
						>
							<Grid item size={{ xs: 1 }} />
							<Grid item size={{ xs: 4 }}>Nombre</Grid>
							<Grid item size={{ xs: 3 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
								Rol
							</Grid>
							<Grid item size={{ xs: 3 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
								Departamento
							</Grid>
							<Grid item size={{ xs: 1 }} />
						</Grid>

						{/* LISTADO DE USUARIOS */}
						<Grid container direction="column" size={{ xs: 11 }}>
							{usuarios.length > 0 ? (
								usuarios.map(usuario => (
									<UsuarioCard
										key={usuario.id}
										usuario={usuario}
										opciones={opcionesUsuario}
										cargarUsuarios={cargarUsuarios}
										roles={roles}
										departamentos={departamentos}
									/>
								))
							) : (
								<Typography variant="body1" sx={{ mt: 2 }}>
									No hay usuarios disponibles
								</Typography>
							)}
						</Grid>
					</Grid>

					{/* =========================
						CREAR USUARIO
					========================= */}
					{openCrearUsuario && (
						<FormCrearUsuario
							open={openCrearUsuario}
							setOpen={setOpenCrearUsuario}
							cargarUsuarios={cargarUsuarios}
							departamentos={departamentos}
							roles={roles}
							tipo="usuario"
						/>
					)}
				</>
			)}
		</div>
	);
};
